// extracted by mini-css-extract-plugin
export default {"box":"ContactBox-module--box--8b580","contactIcon":"ContactBox-module--contactIcon--2ec7f","vertical":"ContactBox-module--vertical--5d1f0","link":"ContactBox-module--link--40e0a"};